module.exports = __webpack_public_path__ + "static/media/bg-footer.12ee79e2.png";